/**
 * Banco local do agente (IndexedDB deste computador): os pontos de restauração e a conversa de
 * cada projeto. Nada disso vai para o servidor.
 */

const DB = "kompil-agent";
const VERSION = 3;

let opening: Promise<IDBDatabase> | null = null;

function open(): Promise<IDBDatabase> {
  // Uma conexão só para a janela inteira (abrir de novo a cada leitura deixava o agente lento).
  opening ??= new Promise((resolve, reject) => {
    const req = indexedDB.open(DB, VERSION);
    req.onupgradeneeded = () => {
      const db = req.result;
      if (!db.objectStoreNames.contains("checkpoints")) {
        const s = db.createObjectStore("checkpoints", { keyPath: "id" });
        s.createIndex("projectId", "projectId");
      }
      if (!db.objectStoreNames.contains("conversations"))
        db.createObjectStore("conversations", { keyPath: "projectId" });
      // Conversas anteriores do agente (Nova conversa arquiva a atual).
      if (!db.objectStoreNames.contains("history")) {
        const h = db.createObjectStore("history", { keyPath: "id" });
        h.createIndex("projectId", "projectId");
      }
    };
    req.onsuccess = () => resolve(req.result);
    req.onerror = () => {
      opening = null;
      reject(req.error);
    };
  });
  return opening;
}

export async function agentDb<T>(
  store: "checkpoints" | "conversations" | "history",
  mode: IDBTransactionMode,
  fn: (s: IDBObjectStore) => IDBRequest<T>,
): Promise<T> {
  const db = await open();
  return new Promise<T>((resolve, reject) => {
    const r = fn(db.transaction(store, mode).objectStore(store));
    r.onsuccess = () => resolve(r.result);
    r.onerror = () => reject(r.error);
  });
}
